import memoize from 'memoize-one';

import {
  MatchingOperator,
  MatchingRuleT,
  MatchingSystemType,
} from 'components/automations/components/nodeTypes/types';

export const getOperatorOptions = memoize(
  (variable?: MatchingRuleT['variable']) => {
    const options: {
      id: MatchingOperator;
      name: string;
    }[] = [];

    const CAN_BE_SINGLE =
      variable === undefined ||
      (variable.scope === 'system' &&
        (
          [
            MatchingSystemType.AGENT_HAS_REPLIED,
            MatchingSystemType.USER_HAS_REPLIED,
            MatchingSystemType.AGENT_HAS_REPLIED_TRIGGER,
            MatchingSystemType.USER_HAS_REPLIED_TRIGGER,
          ] as string[]
        ).includes(variable.variableType));

    const CAN_BE_EMPTY =
      variable === undefined ||
      (variable.scope === 'system' &&
        (
          [MatchingSystemType.TAGS, MatchingSystemType.LANGUAGE] as string[]
        ).includes(variable.variableType));

    const CAN_BE_LIST =
      variable === undefined ||
      (variable.scope === 'system' &&
        (
          [
            MatchingSystemType.QUEUE,
            MatchingSystemType.STATUS,
            MatchingSystemType.TAGS,
            MatchingSystemType.LANGUAGE,
          ] as string[]
        ).includes(variable.variableType));
    const CAN_REQUIRE_MANY =
      variable === undefined ||
      (variable.scope === 'system' &&
        ([MatchingSystemType.TAGS] as string[]).includes(
          variable.variableType,
        ));

    // SINGLE
    if (CAN_BE_SINGLE) {
      options.push({ id: MatchingOperator.EQUALS, name: 'is equal' });
      options.push({
        id: MatchingOperator.NOT_EQUALS,
        name: 'is not equal',
      });
    }

    // LIST
    if (CAN_BE_LIST) {
      options.push({
        id: MatchingOperator.INCLUDES_ONE,
        name: 'includes one of',
      });
      options.push({
        id: MatchingOperator.EXCLUDES_ONE,
        name: 'excludes one of',
      });
    }
    if (CAN_REQUIRE_MANY) {
      options.push({
        id: MatchingOperator.INCLUDES_ALL,
        name: 'includes all of',
      });
      options.push({
        id: MatchingOperator.EXCLUDES_ALL,
        name: 'excludes all of',
      });
    }

    // CAN BE EMPTY
    if (CAN_BE_EMPTY) {
      options.push({ id: MatchingOperator.IS_EMPTY, name: 'is empty' });
      options.push({
        id: MatchingOperator.IS_NOT_EMPTY,
        name: 'is not empty',
      });
    }

    return options;
  },
);
